<template>
  <div>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!seriesId">
          <a-icon type="appstore"/>
          系列模特展示
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button @click="()=>{$router.go(-1)}">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
      <div style="margin: 16px">
        <a-row style="margin-top: 20px" :gutter="20">
          <a-col :span="12">
            <a-card title="模特图">
              <a slot="extra" @click="upSeriesPosition">添加</a>
              <div>
                <img
                  slot="cover"
                  ref="img"
                  alt="example"
                  style="width: 365px;height: 588px"
                  :src="form.data.coverPath"/>
              </div>
            </a-card>
          </a-col>
          <a-col :span="12">
            <a-card title="锚点数据">
              <a-table :data-source="pointTable.data" row-key="id" :pagination="false">
                <a slot="name" slot-scope="text">{{ text }}</a>
                <a-table-column
                  align='center'
                  title="商品图"
                  width="120">
                  <template slot-scope="record">
                    <img :src="record.coverPath" style="width:100px;"/>
                  </template>
                </a-table-column>
                <a-table-column
                  data-index="name"
                  title="商品名称"
                  align='center'
                  width="120">
                </a-table-column>

                <a-table-column
                  data-index="date"
                  :title="$t('OPERATION')||'操作'">
                  <template slot-scope="text, record">
                    <a-button
                      type="link"
                      @click="deleteLookBookPoint(record.id)">{{ $t('REMOVE') || '删除' }}
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-modal
      :visible="goodsSelectForm.visible"
      title="商品选择"
      width="60%"
      :destroyOnClose="true"
      @ok="handleGoodsSelectOk"
      @cancel="handleGoodsSelectCancel">
      <a-form-model :model="currentDiv" :rules="rules" ref="posterPointForm">
        <a-form-model-item label="商品选择" prop="goodsId">
          <img-website-goods-select
            @sumbitName="getGoodName"
            :goods-ids="pointTable.goodsIds"
            v-model="currentDiv.goodsId">
          </img-website-goods-select>
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { _queryGoodsSeriesGather, _updateGoodsSeriesGatherGoods, } from '@/api/websiteGoodsSeriesGatherApi.js';
import ImgWebsiteGoodsSelect from '../../../components/ImgWebsiteGoodsSelect.vue';

async function getGoodsSeriesGather() {
  const result = await _queryGoodsSeriesGather(this.seriesId);
  if (result) {
    this.form.data.coverPath = result.coverPath;
    this.pointTable.data = result.goodsWebsiteList;
    this.goodsIds = result.goodsId;
  }
}

function upSeriesPosition() {
  this.goodsSelectForm.visible = true;
}

function handleGoodsSelectCancel() {
  this.goodsSelectForm.visible = false;
}

function getGoodName(val) {
  this.currentDiv.goodsName = val
}

async function deleteLookBookPoint(relationId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      // 要删除的 relationId  原来的 this.goodsIds
      console.log(this.goodsIds);
      const num = this.goodsIds.length;
      const index = this.goodsIds.indexOf(relationId);
      if (index === num - relationId.length) {
        const ids = this.goodsIds.replace(',' + relationId, '')
        console.log(ids)
        console.log('lastOne')
        const result = await _updateGoodsSeriesGatherGoods(this.seriesId, {
          goodsId: ids,
        })
        if (result) {
          await this.getGoodsSeriesGather();
          this.$message.success('删除成功');
        }
      } else {
        const ids = this.goodsIds.replace(relationId + ',', '')
        const result = await _updateGoodsSeriesGatherGoods(this.seriesId, {
          goodsId: ids,
        })
        if (result) {
          await this.getGoodsSeriesGather();
          this.$message.success('删除成功');
        }
      }
    },
  });
}

function createDivDom(offsetX, offsetY, markerName, goodsName, position) {
  const templateDiv = {
    position: 'left',
    offsetyPer: offsetY,
    offsetxPer: offsetX,
    goodsName: '锚点位置',
    id: offsetX + '-' + offsetY,
    coverPath: ''
  }
  this.pointTable.data.push(templateDiv)
}

async function handleGoodsSelectOk() {
  // 新增的
  const goodsId = this.currentDiv.goodsId;
  // 原来的
  const ids = this.goodsIds + ',' + goodsId;
  const result = await _updateGoodsSeriesGatherGoods(this.seriesId, {
    goodsId: ids,
  })
  if (result) {
    this.goodsSelectForm.visible = false
    await this.getGoodsSeriesGather()
    this.$message.info('添加成功')
  }
}

export default {
  name: 'GoodsSeriesGatherPositions',
  components: {
    ImgWebsiteGoodsSelect,
  },
  props: {
    seriesId: String,
  },
  data() {
    return {
      goodsIds: '',
      goodsSelectForm: {
        visible: false,
      },
      currentDiv: {
        elementObj: null,
        posPertange: [],
        goodsId: '',
        goodsName: '',
        position: 'left',
      },
      rules: {
        position: [{ required: true, trigger: 'blur' }],
        goodsId: [{ required: true, trigger: 'blur' }],
      },
      popconfirmVisible: false,

      coverImg: {
        width: 0,
        height: 0,
      },
      // 已存在的标签Id
      posDivIdList: [],
      form: {
        data: {
          coverPath: '',
        },
        visible: false,
      },
      pointTable: {
        data: [],
        goodsIds: '',
      },
    };
  },
  methods: {
    upSeriesPosition,
    getGoodsSeriesGather,
    handleGoodsSelectOk,
    handleGoodsSelectCancel,
    createDivDom,
    deleteLookBookPoint,
    getGoodName,
  },
  async created() {
    if (this.seriesId) {
      await this.getGoodsSeriesGather();
    }
  },
};
</script>

<style lang="less" scoped>

.popconfirm {
  position: absolute;
  left: 200px;
  top: 200px;
}

.middle-content {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.left-poster {
  width: 375px;
  height: 724px;
  overflow: hidden;
  box-sizing: content-box;
  position: relative;
}

.point-line {
  .font-div-left {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;
  }

  .font-div-right {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;

  }

}

.point-item {
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: white;

}

.font-span {
  display: inline-block;
  white-space: nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  line-height: 100%;
  font-size: 10px;
  margin-left: 10px;
  font-size: 10px;

}

.font-span-left {
  display: inline-block;
  white-space: nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  margin-left: 10px;
  line-height: 11px;

  font-size: 10px;

}

.point-item-left {
  margin-left: 10px;
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: white;

}

.right-table {
  width: calc(100% - 450px);

}

.point-span {
  clip-path: polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%);
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 13px;

  img {
    width: 11px;
    height: 3px;
    margin-left: 19px;
    color: #fff;

  }

}

.right-pos {
  margin-left: 5px;
}

.left-pos {
  margin-right: 5px;
}

</style>
